<template>
    <div class="game-header">
        <div class="header-container">
            <div class="time-display">
                <span class="label">Zeit</span>
                <span class="value">{{ timeLeft }}</span>
                <span class="unit">Sek</span>
            </div>
            <div class="score-display">
                <span class="label">Punkte</span>
                <span class="value">{{ score }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        score: number;
        timeLeft: number;
    }>();
</script>

<style scoped>
    .game-header {
        position: absolute;
        top: 20px;
        left: 20px;
        right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 20;
    }

    .header-container {
        backdrop-filter: blur(20px);
        border-radius: 8px;
        padding: 12px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 60px;
        box-shadow: 0 4px 16px #0000001a;
        border: 2px solid rgba(255, 255, 255, 0.6);
        width: 510px;
        max-width: 90%;
        background: #bd2989;
    }

    .time-display,
    .score-display {
        display: flex;
        align-items: baseline;
        gap: 6px;
    }

    .time-display .label,
    .score-display .label {
        font-size: 16px;
        font-weight: 400;
        color: #fff;
    }

    .time-display .value,
    .score-display .value {
        font-size: 26px;
        font-weight: 700;
        color: #fff;
        line-height: 1;
    }

    .time-display .unit {
        font-size: 16px;
        font-weight: 400;
        color: #fff;
    }
</style>
